import { Converter, Scope } from '@opten/renderer';
import currency from 'currency.js';

export class CurrencyConverter implements Converter {
	fieldType = 'currency';

	private options: currency.Options = {
		increment: 0.05,
		symbol: 'CHF ',
		formatWithSymbol: true,
		separator: ' '
	};

	getFormattedString(value: any, options?: currency.Options): string {
		const price = currency(value, { ...this.options, ...options });
		return price.format(true);
	}

	apply(element: HTMLElement, value: any, index?: number): void | Scope[] {
		element.innerText = this.getFormattedString(value);
	}
}
